<template>
    <div class="fixed-el">
        <div class="nav-menu" :class="{bg: showList}">
            <div class="left" @click="showList = !showList">
                <span class="label">年表：</span>
                <span class="value">{{ part.title }}</span>
                <img v-if="!showList" draggable="false" src="../assets/img/common/nav-icon.png" alt="">
                <div v-else class="close">＋</div>
            </div>
            <div class="right">
                <span class="part">{{ part.part }} |</span>
                <span class="year">{{ part.year }}</span>
            </div>
        </div>

        <transition name="slide-top">
            <div v-if="showList" class="menu-content">
                <div class="items">
                    <div class="item" @click="toPart(i)" data-aos="fade-left" :data-aos-delay="300 + i * 100" v-if="showList" v-for="(p, i) in parts" :key="p.title" :class="{active: p.title === part.title}">
                        <p class="title">{{ p.title }}</p>
                        <p class="info">
                            <span class="part">{{ p.part }} |</span>
                            <span class="year">{{ p.year }}</span>
                        </p>
                    </div>
                </div>
            </div>
        </transition>

        <div class="left-logo">
            <img @click="toHome" src="../assets/img/common/logo.png" alt="">
        </div>

        <div class="mobile-menu-icon" @click="showList = !showList">
            <img v-if="showList" src="../assets/img/common/close.png" alt="">
            <img v-else src="../assets/img/common/list.png" alt="">
        </div>
    </div>
</template>

<script>
export default {
    name: 'FixedEl',
    computed: {
        part() {
            if (!this.$route.name) return {}
            let index = this.$route.name.replace('Part', '') - 1
            return this.parts[index]
        }
    },
    data() {
        return {
            parts: [
                {
                    part: '第一章',
                    title: '青少年时代',
                    year: '1911年 - 1937年'
                },
                {
                    part: '第二章',
                    title: '投身救国宣传',
                    year: '1937年 - 1938年'
                },
                {
                    part: '第三章',
                    title: '延安十年与革命文艺',
                    year: '1938年 - 1948年'
                },
                {
                    part: '第四章',
                    title: '民族英雄史诗画卷',
                    year: '1949年 - 1966年'
                },
                {
                    part: '第五章',
                    title: '最后的岁月',
                    year: '1966年 - 1973年'
                }
            ],

            showList: false
        }
    },
    methods: {
        toPart(index) {
            this.showList = false
            this.$router.replace({ name: `Part${index + 1}` })
        },
        toHome() {
            this.$router.replace({ name: `Home` })
        }
    },
    mounted() {
        this.aos.init({
            duration: 500
        })
    }
}
</script>

<style lang="less">
.fixed-el {
    position: relative;
    z-index: 10;
    .nav-menu {
        position: fixed;
        right: 0;
        top: 0;
        z-index: 10;
        width: calc(100% - 75px);
        height: 75px;
        border-bottom: 1px solid rgba(255, 255, 255, .2);
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 30px 0 36px;
        transition: background-color .3s;
        &.bg {
            background-color: #121212;
        }
        .left {
            display: flex;
            align-items: center;
            cursor: pointer;
            position: relative;
            &::after {
                display: block;
                content: '';
                width: 0;
                height: 1px;
                background-color: #fff;
                position: absolute;
                left: 50%;
                bottom: -5px;
                transform: translateX(-50%);
                transition: width .5s;
            }
            &:hover {
                &::after {
                    width: 100%;
                }
            }
            .label {
                font-size: 18px;
                font-family: Songti SC;
                font-weight: 400;
                color: #CCCCCC;
            }
            .value {
                font-size: 18px;
                font-family: Songti SC;
                font-weight: 400;
                color: #FFFFFF;
                margin: 0 0 0 12px;
            }
            img {
                width: 16px;
                height: 14px;
                cursor: pointer;
                position: absolute;
                right: -26px;
            }
            .close {
                width: 24px;
                height: 24px;
                background: #FFFFFF;
                border-radius: 50%;
                color: #121212;
                display: flex;
                align-items: center;
                justify-content: center;
                overflow: hidden;
                font-size: 22px;
                transform: rotate(45deg);
                cursor: pointer;
                position: absolute;
                right: -34px;
            }
        }
        .right {
            display: flex;
            align-items: center;
            .part {
                font-size: 18px;
                height: 20px;
                font-family: Songti SC;
                font-weight: 400;
                color: #FFFFFF;
                margin-right: 30px;
            }
            .year {
                font-size: 18px;
                font-family: Songti SC;
                font-weight: 400;
                color: #FFFFFF;
            }
        }
    }
    .menu-content {
        position: fixed;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        z-index: 9;
        background-color: #121212;
        padding-top: 162px;
        padding-left: 75px;
        .items {
            width: 100%;
            .item {
                height: 120px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 30px 0 36px;
                cursor: pointer;
                color: #fff;
                .title {
                    font-size: 36px;
                    font-family: Songti SC;
                    font-weight: 400;
                    line-height: 48px;
                }
                .info {
                    .part {
                        font-size: 18px;
                        font-family: Songti SC;
                        font-weight: 400;
                        margin-right: 30px;
                    }
                    .year {
                        font-size: 18px;
                        font-family: Songti SC;
                        font-weight: 400;
                    }
                }
                &:hover {
                    background-color: #555;
                }
                &.active {
                    background-color: #fff;
                    color: #121212;
                }
            }
        }
    }
    .left-logo {
        width: 75px;
        height: 100%;
        overflow: hidden;
        border-right: 1px solid rgba(255, 255, 255, .2);
        position: fixed;
        left: 0;
        top: 0;
        z-index: 10;
        img {
            width: 31px;
            height: 140px;
            margin-top: 30px;
            margin-left: 22px;
            cursor: pointer;
        }
    }
    .mobile-menu-icon {
        display: none;
    }
}
@media screen and (max-width: 479px) {
    .fixed-el {
        .nav-menu {
            width: 100%;
            height: 3rem;
            border-bottom: none;
            padding: 0 20px 0 36px;
            .left {
                opacity: 0;
            }
            .right {
                float: right;
                display: flex;
                align-items: center;
                .part {
                    display: none;
                }
                .year {
                    font-size: 18px;
                    font-family: Songti SC;
                    font-weight: 400;
                    color: #FFFFFF;
                }
            }
        }
        .menu-content {
            padding-top: 5rem;
            padding-left: 0;
            .items {
                width: 100%;
                .item {
                    flex-direction: column;
                    justify-content: center;
                    align-items: flex-start;
                    height: 4rem;
                    padding: 0 1rem 0 1rem;
                    .title {
                        font-size: .9rem;
                        margin-bottom: .9rem;
                    }
                    .info {
                        .part {
                            font-size: .7rem;
                        }
                        .year {
                            font-size: .7rem;
                        }
                    }
                }
            }
        }
        .left-logo {
            width: 100%;
            height: 3rem;
            border-bottom: 1px solid rgba(255, 255, 255, .2);
            border-right: none;
            img {
                transform: rotate(90deg);
                width: 1.55rem;
                height: 7rem;
                margin-top: -1.925rem;
                margin-left: 3.5rem;
            }
        }
        .mobile-menu-icon {
            display: flex;
            justify-content: center;
            align-items: center;
            position: fixed;
            width: 2.4rem;
            height: 2.4rem;
            z-index: 10;
            bottom: 2rem;
            right: 1rem;
            background-color: #fff;
            border-radius: 50%;
            img {
                width: 1.6rem;
                height: 1.6rem;
            }
        }
    }
}
</style>
